import {Component, OnInit} from '@angular/core';
import {CatalogService} from "../catalog.service";
import {UserService} from "../../../common/user.service";
import {LoggerService} from "../../../common/logger.service";
import {BaseComponent} from "../../../base.component";
import {ICatalogView, ICategory, INavItem, ITag} from "../catalog-models";
import {Observable, of} from "rxjs";
import {CategoryService} from "../../../category/category.service";
import {map, switchMap} from "rxjs/operators";
import * as _ from "lodash";

@Component({
    selector: 'side-navigation',
    templateUrl: './side-navigation.component.html',
    styleUrls: ['./side-navigation.component.scss'],
    standalone: false
})
export class SideNavigationComponent extends BaseComponent implements OnInit {

    filterView$: Observable<ICatalogView>;
    bodyBenefits$: Observable<ITag[]>;
    lifestyles$: Observable<ITag[]>;
    navCategories$: Observable<INavItem[]>;

    constructor(
        private catalogService: CatalogService,
        private userService: UserService,
        private loggerService: LoggerService,
        private categoryService: CategoryService
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.filterView$ = this.catalogService.filterView$;

        this.bodyBenefits$ = this.categoryService.getBodyBenefits();
        this.lifestyles$ = this.categoryService.getLifeStyles();

        this.navCategories$ = this.categoryService.getNavCategories().pipe(
            switchMap((categories) => this.getAllCategory().pipe(
                    map((allCategory) => {
                        const tempCategories = _.cloneDeep(categories);
                        tempCategories.unshift(allCategory);
                        return tempCategories;
                    })
                ))
        );
    }

    isAccordionOpen(isOpen: boolean) {
        return isOpen ? 'fa-chevron-down': 'fa-chevron-right';
    }

    sideNavToggle() {
        this.catalogService.sideNavToggle();
    }

    clearFilters() {
        this.catalogService.clearFilters();
    }

    getAllCategory(): Observable<INavItem> {
        const allCat: ICategory = {
            id: -1,
            name: '',
            translationTag: 'cart.all',
            order: -1,
            imagePath: '',
            isChild: false,
            children: []
        };
        return of(allCat);
    }
}
